import { jsx as _jsx } from "react/jsx-runtime";
import { SvgInfo } from '../../index';
import { Alert, SIZE } from './Alert';
export { SIZE };
export const InfoAlert = (props) => {
    return _jsx(Alert, { type: 'info', icon: _jsx(SvgInfo, {}), ...props });
};
//# sourceMappingURL=InfoAlert.js.map